import React from 'react'
import { scaleDimensions, getHexColor } from '../utils'
import { OneColorLogoProps } from './LogoTypes'

export const SpectrumLogo: React.FC<OneColorLogoProps> = ({ height = 32, color = 'white', className }) => {
  const { width: scaledWidth, height: scaledHeight } = scaleDimensions(height, 47, 18)
  const hex = getHexColor(color)

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      className={className}
      width={scaledWidth}
      height={scaledHeight}
      aria-label={'Spectrum Logo'}
      viewBox="0 0 1000.786 209.086"
      enable-background="new 0 0 1000.786 209.086"
    >
      <g>
        <polygon fill={hex} points="933.78,61.306 933.78,163.002 1000.786,112.168 	" />
        <path
          fill={hex}
          d="M166.332,193.412c0,8.211-6.393,15.674-15.68,15.674h-15.674V94.303
		c1.825-30.536,12.928-54.874,59.314-56.534c20.063,0.252,34.621,8.229,43.223,18.29c9.219,11.989,13.173,26.885,13.173,45.62
		c0,19.359-4.612,35.034-13.837,47.022c-9.219,11.68-21.048,17.517-35.492,17.517c-21.665,0-32.188-9.019-35.05-10.712
		C166.31,156.553,166.332,193.412,166.332,193.412 M218.877,103.063c0-11.983-2.197-37.339-26.736-37.339
		c-23.302,0-25.809,24.739-25.809,37.339c0,31.903,18.129,35.955,26.73,35.955C215.34,139.019,218.877,115.391,218.877,103.063"
        />
        <path
          fill={hex}
          d="M18.341,152.741c10.387,8.87,25.986,13.294,46.782,13.294c20.184,0,35.783-4.27,46.787-12.836
		c11.005-9.174,16.516-22.015,16.516-38.524c0-7.64-1.499-14.69-5.047-21.105c-3.25-5.871-8.768-11.411-15.439-14.752
		c-4.234-2.112-6.811-3.033-12.018-4.636c-5.619-1.722-33.604-9.356-36.43-10.1c-15.588-3.8-25.488-8.99-25.557-18.215
		c0.807-17.837,17.43-19.262,26.609-19.262c9.465,0,16.967,1.991,22.467,5.963c9.877,7.686,8.778,17.448,8.778,17.448h31.125
		c-0.612-15.291-6.117-27.686-16.509-37.168C96.316,4.287,81.936,0,63.292,0c-19.88,0-35.011,4.132-45.409,12.384
		C7.485,20.951,2.289,32.722,2.289,47.704c0.046,19.245,9.168,30.593,17.432,35.777c5.018,3.004,16.424,7.611,31.188,10.547
		l12.4,2.701c21.506,5.242,33.85,11.881,33.466,22.53c-0.234,6.415-2.443,11.319-7.342,14.679
		c-4.476,3.061-12.087,5.035-21.552,5.035c-10.713,0-19.113-2.129-25.225-6.415c-5.814-3.668-9.34-10.089-10.553-19.262H0
		C0.916,130.721,7.027,143.877,18.341,152.741"
        />
        <path
          fill={hex}
          d="M313.945,64.826c19.715-0.269,22.776,16.515,23.389,24.773h-46.782
		C290.552,89.599,290.157,65.266,313.945,64.826 M315.325,138.676c-7.948-0.401-23.079-1.957-24.464-28.436l79.48,0.017
		c0.012-0.813,0-9.528,0.023-9.54c-0.55-19.955-5.34-34.822-14.685-45.981c-10.095-11.01-24.31-16.509-42.656-16.509
		c-17.419,0-31.033,5.66-40.813,16.967c-9.482,11.005-14.227,26.301-14.227,45.866c0,20.492,4.888,36.235,14.685,47.24
		c9.786,11.318,23.394,16.973,40.813,16.973c14.381,0,26.301-3.508,35.777-10.547c9.477-6.724,15.943-16.543,19.309-29.391
		l-27.617,0.006C336.888,136.867,326.501,139.236,315.325,138.676"
        />
        <path
          fill={hex}
          d="M847.622,163.15h-31.801V84.786c0-9.036-3.715-21.208-21.666-21.208c-17.613,0-21.201,13.837-21.201,21.208
		v78.365h-32.275v-71.91c0-20.893,6.197-33.66,16.365-41.946c10.072-8.212,22.965-10.907,36.184-11.525
		c7.068,0,13.992,0.773,20.746,2.301c6.764,1.551,12.91,4.612,18.443,9.225c4.617-3.989,10.061-6.838,16.365-8.532
		c6.295-1.683,12.814-2.958,19.59-2.993c39.359-0.206,55.154,17.814,56.465,23.594c0,0.086,0.01,101.787,0.01,101.787h-18.215
		c-4.605,0-15.668-3.13-15.668-15.668V84.786c0.08-8.881-3.033-21.208-21.672-21.208c-18.449,0-21.67,13.837-21.67,21.208V163.15z"
        />
        <path
          fill={hex}
          d="M457.994,125.382h30.152c0,0-8.184,39.892-53.734,39.892c-45.541,0-56.752-36.544-56.752-60.562
		c0-24.012,4.264-65.037,54.982-66.474c46.863-0.704,54.588,39.898,54.588,39.898h-32.109c0,0-3.107-13.723-22.221-13.293
		c-19.107,0.435-24.104,18.381-24.104,35.434c0,17.059,4.246,38.399,25.466,38.399C454.435,139.293,456.215,128.381,457.994,125.382
		"
        />
        <path
          fill={hex}
          d="M625.282,40.951h32.104v77.97c0,0-1.156,21.088,21.105,21.099c20.99,0.012,21.527-18.867,21.545-20.2
		V56.082c0,0,1.082-15.13,15-15.13H731.7c0,0-0.018,71.727,0,72.413c-0.23,3.948,4.199,51.915-53.209,51.721
		c-56.877,0-52.848-48.527-53.209-51.383V40.951z"
        />
        <path
          fill={hex}
          d="M527.055,73.581h18.855l-0.018-32.144h-18.799V20.791c0-5.66-3.152-15.594-15.137-15.594h-16.509v134.858
		c0,14.061,5.455,22.473,17.265,22.473c0.133,0,13.85,0.011,14.348,0.011L527.055,73.581z"
        />
        <path
          fill={hex}
          d="M579.512,162.762v-62.84c0-9.167,2.129-15.897,6.422-20.178c4.275-4.28,10.844-6.426,19.719-6.426h10.541
		V40.756c0,0-16.605-0.412-28.664,3.21c-7.742,2.329-14.598,5.505-20.4,10.083c-6.135,4.898-10.941,11.399-14.455,19.497
		c-3.514,8.103-5.27,18.117-5.27,30.043v59.171H579.512z"
        />
      </g>
    </svg>
  )
}
